import type { CardInstanceId, RunState } from "../types/index.js";

export function innRequiredCount(handLength: number): number {
  return Math.min(2, handLength);
}

export function toggleInn(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "inn") return null;
  if (!run.hand.some((card) => card.instanceId === id)) return null;
  if (pending.selected.length >= 2 && !pending.selected.includes(id)) return null;
  const selected = pending.selected.includes(id)
    ? pending.selected.filter((item) => item !== id)
    : [...pending.selected, id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveInn(run: RunState): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "inn") return { ...run, pendingChoice: null };
  if (pending.selected.length !== innRequiredCount(run.hand.length)) return null;
  const chosen = run.hand.filter((card) => pending.selected.includes(card.instanceId));
  const hand = run.hand.filter((card) => !pending.selected.includes(card.instanceId));
  return {
    ...run,
    hand,
    discard: [...run.discard, ...chosen],
    pendingChoice: null,
  };
}
